import React, { Component } from "react";
import ReactDOM from "react-dom/client";
import ReactSelect, { components } from "react-select";
import { flushSync } from "react-dom";
import { get } from "../Libraries/Ajax/HttpService";
import { useDistrict } from "../utils/DistrictContext";
import { useTheme } from "../context/ThemeContext";
// const customSelectStyles = {
//   control: (base, state) => ({
//     ...base,
//     backgroundColor: "#0a1628", // Matches your Tailwind bg
//     borderColor: state.isFocused ? "#00b8f1" : "#2a2520", // Matches border and focus blue
//     borderRadius: "0.5rem", // rounded-lg
//     padding: "2px 6px",
//     boxShadow: "none",
//     "&:hover": {
//       borderColor: "#00b8f1",
//     },
//   }),
//   menu: (base) => ({
//     ...base,
//     backgroundColor: "#0f1f30", // Slightly lighter navy for dropdown
//     border: "1px solid #2a2520",
//     zIndex: 9999,
//   }),
//   option: (base, state) => ({
//     ...base,
//     backgroundColor: state.isFocused ? "#00b8f120" : "transparent",
//     color: state.isSelected ? "#00b8f1" : "#fff",
//     "&:active": {
//       backgroundColor: "#00b8f140",
//     },
//   }),
//   multiValue: (base) => ({
//     ...base,
//     backgroundColor: "#00b8f120",
//     borderRadius: "4px",
//   }),
//   multiValueLabel: (base) => ({
//     ...base,
//     color: "#fff",
//   }),
//   multiValueRemove: (base) => ({
//     ...base,
//     color: "#00b8f1",
//     "&:hover": {
//       backgroundColor: "#00b8f140",
//       color: "#fff",
//     },
//   }),
//   input: (base) => ({
//     ...base,
//     color: "#fff",
//   }),
//   singleValue: (base) => ({
//     ...base,
//     color: "#fff",
//   }),
//   placeholder: (base) => ({
//     ...base,
//     color: "#BDB9B5",
//   }),
// };
const Option = (props) => (
  <components.Option {...props}>
    <label>{props.label}</label>
  </components.Option>
);

class Example extends Component {
  constructor(props) {
    super(props);
    this.state = {
      optionSelected: [],
      items: [],
      productsnew: [],
    };
  }

  async componentDidMount() {
    await this.loadAccounts();
  }

  async componentDidUpdate(prevProps) {
    if (prevProps.selectedDistrict !== this.props.selectedDistrict) {
      await this.loadAccounts();
    }
  }

  loadAccounts = async () => {
    const response = await get(`apis/account/overide_name/select/list`);
    const accountList = response?.data?.data?.account_override_list || [];
    const items = accountList.map(({ overided_name }) => ({
      label: overided_name,
      value: overided_name,
    }));

    const { selectedDistrict } = this.props;
    const user = JSON.parse(localStorage.getItem("MCData"));
    console.log("districtkkkkkkkk", selectedDistrict);

    let optionSelected = [];
    // if (selectedDistrict !== "FB151" && user?.userid) {
    //   optionSelected = [{ label: "PHMSCM Holdings", value: "PHMSCM Holdings" }];
    // } else {
    //   optionSelected = [{ label: "429700", value: "429700" }];
    // }

    // this.setState({ items, optionSelected, productsnew: [] });

    // if (optionSelected.length > 0) {
    //   this.handleChange(optionSelected);
    // }
    this.setState({ items, optionSelected, productsnew: [] });

    // This will trigger handleCallback in the parent with an empty selection
    this.handleChange(optionSelected);
  };

  // handleChange = async (selected) => {
    
  //   flushSync(() => {
  //     this.setState({ optionSelected: [...selected] });
  //   });

  //   const product = selected.map((s) => encodeURIComponent(s.value));
  //   const res = await get(
  //     `apis/meter/account_override/select?selected=${JSON.stringify(product)}`,
  //   );

  //   const selectedMeters = res?.data?.data?.meters?.selected_meters || [];
  //   const products = selectedMeters.flatMap((group) =>
  //     group.meters.map((m) => m.meter_unique_name),
  //   );

  //   this.setState({ productsnew: products });

  //   if (selectedMeters.length === 0) {
  //     this.props?.parentCallback(res);
  //   } else {
  //     this.props?.parentCallback(res, products);
  //   }
  // };
  handleChange = async (selected) => {
  // If 'selected' is null or empty, we pass an empty array to the API
  const selectionForApi = selected && selected.length > 0 
    ? JSON.stringify(selected.map((s) => encodeURIComponent(s.value))) 
    : "[]"; // Pass "null" string as per your requirement

  flushSync(() => {
    this.setState({ optionSelected: selected || [] });
  });

  const res = await get(
    `apis/meter/account_override/select?selected=${selectionForApi}`
  );

  const selectedMeters = res?.data?.data?.meters?.selected_meters || [];
  const products = selectedMeters.flatMap((group) =>
    group.meters.map((m) => m.meter_unique_name)
  );

  this.setState({ productsnew: products });
  this.props?.parentCallback(res, products);
};

  render() {
    const { items, optionSelected } = this.state;

    if (!items.length) {
      // return <div></div>; // or <Skeleton />
      return (
        <div
          className="h-10 animate-pulse rounded-lg"
          style={{
            background: `${this.props.selectStyles?.control({}, { isFocused: false }).backgroundColor}40`,
          }}
        ></div>
      );
    }
    return (
      <span
        className="d-inline-block"
        data-toggle="popover"
        data-trigger="focus"
        data-content="Please select account(s)"
      >
        <ReactSelect
          classNamePrefix="rs"
          // styles={{ menuPortal: (base) => ({ ...base, zIndex: 99999 }) }}
          styles={this.props.selectStyles}
          options={this.state.items}
          isMulti
          components={{ Option }}
          onChange={this.handleChange}
          value={this.state.optionSelected}
          menuPortalTarget={document.body}
          menuPosition="fixed"
          maxMenuHeight={300}
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
        />
      </span>
    );
  }
}

function ExampleWithDistrict(props) {
  const districtContext = useDistrict();
  const { colors } = useTheme();

  const selectedDistrict =
    typeof districtContext === "string"
      ? districtContext
      : districtContext?.selectedDistrict || "";

  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      backgroundColor: colors.background,
      borderColor: state.isFocused ? colors.primary : colors.border,
      borderRadius: "0.5rem",
      padding: "2px 6px",
       maxHeight: "45px", // Set maximum height for the dropdown
    overflowY: "auto", // Enable vertical scrolling
      boxShadow: "none",
      "&:hover": {
        borderColor: colors.primary,
      },
    }),

    menu: (base) => ({
      ...base,
      backgroundColor: colors.background,
      border: `1px solid ${colors.border}`,
      zIndex: 9999,
    }),

    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? `${colors.primary}20` : "transparent",
      color: state.isSelected ? colors.primary : colors.text,
      "&:active": {
        backgroundColor: `${colors.primary}40`,
      },
    }),

    multiValue: (base) => ({
      ...base,
      backgroundColor: `${colors.primary}20`,
      borderRadius: "4px",
    }),

    multiValueLabel: (base) => ({
      ...base,
      color: colors.text,
    }),

    multiValueRemove: (base) => ({
      ...base,
      color: colors.primary,
      "&:hover": {
        backgroundColor: `${colors.primary}40`,
        color: colors.text,
      },
    }),

    input: (base) => ({
      ...base,
      color: colors.text,
    }),

    singleValue: (base) => ({
      ...base,
      color: colors.text,
    }),

    placeholder: (base) => ({
      ...base,
      color: colors.textSecondary,
    }),
  };

  return (
    <Example
  {...props}
  selectedDistrict={selectedDistrict}
  selectStyles={customSelectStyles}
/>
  );
}

export default ExampleWithDistrict;
